module.exports = "img/flags/VI.3d149d6.png";